<template>

    <el-cascader v-model="value" placeholder="请选择" :options="options" filterable tag-type="danger"
                 :props="{emitPath:false}" @change="handleChange" :disabled="disable" style="width: 98%;">
    </el-cascader>


</template>

<script>
import {mapStores} from "pinia";
import {useApplicationStore} from "@/stores/application";
import {useMenuStore} from "@/stores/menu";

export default {
  emits:['change','update:modelValue'],
  props: {
    formId:{
      type:String,
      default:null
    },
    modelValue: {
      type: String,
      default: () => ""
    },
    disable: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    ...mapStores(useApplicationStore, useMenuStore)
  },
  data() {
    return {
      value: '',
      options: [],
    }
  },
  created() {
    this.queryList();
  },
  watch: {
    modelValue: {
      handler(newValue, oldValue) {
        this.value = newValue;
      },
      immediate: true
    }
  },
  methods: {
    async queryList() {

      this.options = []
      let res = await this.applicationStore.getList();
      let applications = res.data;

      for (let application of applications) {
        let res = await this.menuStore.list('form', application.id);
        let forms = res.data;
        this.options.push({
          label: application.name,
          value: application.id,
          children: forms.map(form => {
            return {
              label: form.name,
              value: form.id,
              // disabled:false,
              disabled: form.id  === this.formId,
            }
          })
        })

      }
    },
    handleChange() {
      this.$emit("update:modelValue", this.value);
      this.$emit('change',this.value)
    }
  }


}

</script>

<style scoped lang="scss">


</style>